@import 'styles/mixins';
@import 'styles/variables';

.inputWithActions {
  display: flex;
  align-items: flex-start;
  gap: 12px;

  .inputWrapper {
    flex: 1;
    min-width: 0;

    input {
      border-radius: 4px;
      padding: 5px 12px;
      height: 32px;
      width: 100%;
      margin-top: 10px;
      border: 1px solid $gray-20;

      &:focus {
        border-color: $green-50;
      }

      &:disabled {
        background-color: white;
      }
    }
  }

  .inputActions {
    margin-top: 10px;
    display: flex;
    gap: 12px;

    button {
      flex-shrink: 0;
      height: 32px;
    }
  }
}

@include for-phone-only {
  .inputWithActions {
    flex-direction: column;

    .inputActions {
      margin-top: 12px;
    }
  }
}
